// extracted by mini-css-extract-plugin
module.exports = {"box":"_3aL7o","desc":"_124V3","dialogActions":"_12Cmh"};